export class Helper {

static backGroundColor = "#212E53";
static navBarFooterGroundColor = "#0b0f34";
static footerBackGroundColor = "#0b0f34";

static navBarColorLetter = "#d3ccaa";
static contentLetterColor = "#d3ccaa";

static urlReservation = "//www.abaseo.fr/chiropracteur/14100-ouilly-le-vicomte";

static urlReservationEmilie = "//www.abaseo.fr/chiropracteur/14100-ouilly-le-vicomte/emilie-gouache?officeId=0192480f-5df8-798d-a106-1846fc1d9557";
static urlReservationAlexis = "//www.abaseo.fr/chiropracteur/14100-ouilly-le-vicomte/alexis-moulin?officeId=0192480f-5df8-798d-a106-1846fc1d9557";



}